export default __webpack_public_path__ + "static/media/arapyau.f29b997a.png";